export const Events = {
  SIGNED_UP: { name: "user_signed_up", friendlyName: "Signed Up" },
  PROFILE_VIEWED: { name: "viewed_profile", friendlyName: "Viewed Profile" },
  CLICKED_POKE: { name: "clicked_poke", friendlyName: "Clicked Poke" },
  CLICKED_MESSAGE: { name: "clicked_message", friendlyName: "Clicked Message" },
  CLICKED_NEXT_PROFILE: {
    name: "clicked_next_profile",
    friendlyName: "Clicked Next Profile",
  },
  CLICKED_GET_CREDITS: {
    name: "clicked_get_credits",
    friendlyName: "Clicked Get Credits",
  },
  CLICKED_PROFILE_MY_PHOTO: {
    name: "clicked_profile_my_photo",
    friendlyName: "Clicked Profile My Photo",
  },
  CLICKED_PROFILE_PRIVATE_PHOTO: {
    name: "clicked_profile_private_photo",
    friendlyName: "Clicked Profile Private Photo",
  },
  CLICKED_REQUEST_PRIVATE_PHOTO: {
    name: "clicked_request_private_photo",
    friendlyName: "Clicked Request Private Photo",
  },
  CLICKED_SIMILAR_PROFILE: {
    name: "clicked_similar_profile",
    friendlyName: "Clicked Similar Profile",
  },
  CLICKED_VERIFY_EMAIL: {
    name: "clicked_verify_email",
    friendlyName: "Clicked Verify Email",
  },
  CLICKED_FILTER_ICON: {
    name: "clicked_filter_icon",
    friendlyName: "Clicked Filter Icon",
  },
  SEARCHED_PROFILES: {
    name: "searched_profiles",
    friendlyName: "Searched Profiles",
  },
  MESSAGE_SENT: { name: "message_sent", friendlyName: "Message Sent" },
  PHOTO_SENT: { name: "photo_sent", friendlyName: "Photo Sent" },
  PURCHASED_CREDITS: {
    name: "purchased_credits",
    friendlyName: "Purchased Credits",
  },
  CLICKED_PURCHASE_CREDITS: {
    name: "clicked_purchase_credits",
    friendlyName: "Clicked Purchase Credits",
  },
  LOGGED_IN: { name: "logged_in", friendlyName: "Logged In" },
  LOGGED_OUT: { name: "logged_out", friendlyName: "Logged Out" },
  UPLOADED_PROFILE_PHOTO: {
    name: "uploaded_profile_photo",
    friendlyName: "Uploaded Profile Photo",
  },
  COMPLETED_PROFILE_PHOTO: {
    name: "completed_profile_photo",
    friendlyName: "Completed Profile Photo",
  },
  DELETED_PROFILE_PHOTO: {
    name: "deleted_profile_photo",
    friendlyName: "Deleted Profile Photo",
  },
  CHANGED_PROFILE_PHOTO: {
    name: "changed_profile_photo",
    friendlyName: "Changed Profile Photo",
  },
  COMPLETED_MY_DETAILS: {
    name: "completed_my_details",
    friendlyName: "Completed My Details",
  },
  COMPLETED_ABOUT_ME: {
    name: "completed_about_me",
    friendlyName: "Completed About Me",
  },
  COMPLETED_LOOKING_FOR: {
    name: "completed_looking_for",
    friendlyName: "Completed Looking For",
  },
  COMPLETED_MY_INTERESTS: {
    name: "completed_my_interests",
    friendlyName: "Completed My Interests",
  },
  COMPLETED_EMAIL_VERIFICATION: {
    name: "completed_email_verification",
    friendlyName: "Completed Email Verification",
  },
  OUT_OF_CREDITS_POPUP: {
    name: "out_of_credits_popup",
    friendlyName: "Out Of Credits Popup",
  },
  PURCHASE_CREDITS_POPUP: {
    name: "purchase_credits_popup",
    friendlyName: "Purchase Credits Popup",
  },
  UNLOCKED_MESSAGE: {
    name: "unlocked_message",
    friendlyName: "Unlocked Message",
  },
  CONVERSATION_VIEWED: {
    name: "viewed_conversation",
    friendlyName: "Viewed Conversation",
  },
  SENT_PASSWORD_RESET_EMAIL: {
    name: "sent_password_reset_email",
    friendlyName: "Sent Password Reset Email",
  },
  SENT_NEW_MESSAGE_EMAIL: {
    name: "sent_new_message_email",
    friendlyName: "Sent New Message Email",
  },
  LP_CHAT_VIEWED: {
    name: "lp_chat_viewed",
    friendlyName: "Landing Page Chat Viewed",
  },
  LP_CHAT_CLICKED_PROFILE_LIST: {
    name: "lp_chat_clicked_profile_list",
    friendlyName: "Landing Page Chat Clicked Profile List",
  },
  LP_CHAT_REGISTER_POPUP: {
    name: "lp_chat_register_popup",
    friendlyName: "Landing Page Chat Register Popup",
  },
  VOLUUM_POSTBACK_ERROR: {
    name: "voluum_postback_error",
    friendlyName: "Voluum Postback Error",
  },
  // Both outcomes are tracked: without the success event there is no denominator, so a
  // delivery rate cannot be computed and a drop in postbacks looks like a quiet day.
  REDTRACK_POSTBACK_SENT: {
    name: "redtrack_postback_sent",
    friendlyName: "RedTrack Postback Sent",
  },
  REDTRACK_POSTBACK_ERROR: {
    name: "redtrack_postback_error",
    friendlyName: "RedTrack Postback Error",
  },
  GENERAL_POSTBACK_ERROR: {
    name: "general_postback_error",
    friendlyName: "General Postback Error",
  },
  LP_CHOICES_VIEWED: {
    name: "lp_choices_viewed",
    friendlyName: "Landing Page Choices Viewed",
  },
  LP_CHOICES_STEP_COMPLETED: {
    name: "lp_choices_step_completed",
    friendlyName: "Landing Page Choices Step Completed",
  },
  LP_COINLANDER_VIEWED: {
    name: "lp_coinlander_viewed",
    friendlyName: "Landing Page Coinlander Viewed",
  },

  LP_CAROUSEL_VIEWED: {
    name: "lp_carousel_viewed",
    friendlyName: "Landing Page Carousel Viewed",
  },

  LP_VCHAT_VIEWED: {
    name: "lp_vchat_viewed",
    friendlyName: "Landing Page Vchat Viewed",
  },

  LP_PREVIEW_VIEWED: {
    name: "lp_preview_viewed",
    friendlyName: "Landing Page Preview Viewed",
  },

  LP_NEXTGIRL_VIEWED: {
    name: "lp_nextgirl_viewed",
    friendlyName: "Landing Page NextGirl Viewed",
  },

  LP_STANDARD_VIEWED: {
    name: "lp_standard_viewed",
    friendlyName: "Landing Page Standard Viewed",
  },

  LP_NAUGHTY_VIEWED: {
    name: "lp_naughty_viewed",
    friendlyName: "Landing Page Naughty Viewed",
  },

  LP_URGENT_VIEWED: {
    name: "lp_urgent_viewed",
    friendlyName: "Landing Page Urgent Viewed",
  },

  LP_MATURE_VIEWED: {
    name: "lp_mature_viewed",
    friendlyName: "Landing Page Mature Viewed",
  },

  LP_MAP_VIEWED: {
    name: "lp_map_viewed",
    friendlyName: "Landing Page Map Viewed",
  },

  LP_SIDESCROLLER_VIEWED: {
    name: "lp_sidescroller_viewed",
    friendlyName: "Landing Page Sidescroller Viewed",
  },

  LP_ROWCARDS_VIEWED: {
    name: "lp_rowcards_viewed",
    friendlyName: "Landing Page Rowcards Viewed",
  },

  LP_DAYGIRL_VIEWED: {
    name: "lp_daygirl_viewed",
    friendlyName: "Landing Page DayGirl Viewed",
  },

  WIZARD_STARTED: {
    name: "wizard_started",
    friendlyName: "wizard_started",
  },
  WIZARD_COMPLETED: {
    name: "wizard_completed",
    friendlyName: "wizard_completed",
  },
  WIZARD_STEP_VIEWED: {
    name: "wizard_step_viewed",
    friendlyName: "wizard_step_viewed",
  },
  DAILY_REWARD_CLAIMED: {
    name: "daily_reward_claimed",
    friendlyName: "Daily Reward Claimed",
  },
  DAILY_REWARD_BLOCKED: {
    name: "daily_reward_blocked",
    friendlyName: "Daily Reward Blocked",
  },
  DAILY_REWARD_WINDOW_RESET: {
    name: "daily_reward_window_reset",
    friendlyName: "Daily Reward Window Reset",
  },
  UPLOADED_GALLERY_PHOTO: {
    name: "uploaded_gallery_photo",
    friendlyName: "Uploaded Gallery Photo",
  },
  TOGGLED_PHOTO_PRIVACY: {
    name: "toggled_photo_privacy",
    friendlyName: "Toggled Photo Privacy",
  },
  DELETED_GALLERY_PHOTO: {
    name: "deleted_gallery_photo",
    friendlyName: "Deleted Gallery Photo",
  },
  VIEWER_TOAST_CLICKED: {
    name: "viewer_toast_clicked",
    friendlyName: "Viewer Toast Clicked",
  },
  VIEWER_TOAST_SHOWN: {
    name: "viewer_toast_shown",
    friendlyName: "Viewer Toast Shown",
  },
  CLICKED_PENDING_NOTIFICATION: {
    name: "user_clicked_pending_notification",
    friendlyName: "Clicked Pending Notification",
  },
  PROFILE_SUSPENDED_CHARGEBACK: {
    name: "profile_suspended_chargeback",
    friendlyName: "Profile Suspended (Chargeback)",
  },
  //add LP_CHAT_REGISTER_POPUP event here and others
};
